export function compact<T>(array: (T | undefined | null)[]): T[] {
  return array.filter((item) => item) as T[];
}

// compact and remove errors
export function compactErrors<T>(array: (T | undefined | null | Error)[]): T[] {
  return array.filter((item) => item && !(item instanceof Error)) as T[];
}
